import { useCallback, useState } from "react";
export default (function (ref, childrenRef, children, collapsed) {
    var _a = useState(false), arrowLeft = _a[0], setArrowLeft = _a[1];
    var _b = useState(false), arrowRight = _b[0], setArrowRight = _b[1];
    var onScroll = useCallback(function () {
        if (!ref.current || !childrenRef.current)
            return;
        if (!collapsed)
            return;
        var container = ref.current;
        var tabs = childrenRef.current;
        if (!Array.isArray(tabs) || !tabs.length)
            return;
        var lastTab = tabs[tabs.length - 1];
        var scroll = container.scrollLeft;
        var containerRight = container.getBoundingClientRect().right;
        var lastTabRight = lastTab.getBoundingClientRect().right;
        if (lastTabRight > containerRight)
            setArrowRight(true);
        if (lastTabRight <= containerRight)
            setArrowRight(false);
        if (scroll > 0)
            setArrowLeft(true);
        if (scroll === 0)
            setArrowLeft(false);
    }, [collapsed, children]);
    return [arrowLeft, arrowRight, onScroll];
});
